export default __webpack_public_path__ + "static/media/blue_arrow.6e55113d.svg";